(() => {
  const controls = document.querySelectorAll('[data-esenza-cookie-preferences]');
  const available = () => typeof window.privacyBanner?.showPreferences === 'function';
  const reveal = () => {
    if (!available()) return false;
    controls.forEach((button) => { button.hidden = false; });
    return true;
  };
  controls.forEach((button) => {
    button.addEventListener('click', async () => {
      const status = button.parentElement.querySelector('[data-esenza-cookie-status]');
      status.textContent = '';
      try {
        await window.privacyBanner.showPreferences();
      } catch {
        status.textContent = 'Preferințele nu au putut fi deschise. Reîncarcă pagina și încearcă din nou.';
      }
    });
  });
  if (!reveal()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      if (reveal() || ++attempts >= 40) window.clearInterval(timer);
    }, 250);
  }
})();
